import React, { useEffect, useState } from 'react';
import {
  Box,
  Typography,
  Paper,
  Container,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  CircularProgress,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  Button
} from '@mui/material';
import { ArrowBack } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import api from '../../services/api';

const ShopPendingIssues = () => {
  const [rows, setRows] = useState([]);
  const [karigars, setKarigars] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [karigarFilter, setKarigarFilter] = useState('');
  const [karatFilter, setKaratFilter] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const [ordersRes, directOrdersRes, karigarsRes] = await Promise.all([
          api.get('/api/shop/orders'),
          api.get('/api/shop/direct-orders'),
          api.get('/api/karigar')
        ]);
        setKarigars(karigarsRes.data);
        const itemRows = [
          ...ordersRes.data.flatMap(order =>
            (order.items || [])
              .filter(item => item.despatchStatus && !item.workIssued)
              .map(item => ({
                karigar: item.karigarAbbreviation || '',
                karat: item.karat
              }))
          ),
          ...directOrdersRes.data.flatMap(order =>
            (order.items || [])
              .filter(item => item.despatchStatus && !item.workIssued)
              .map(item => ({
                karigar: item.karigarAbbreviation || '',
                karat: item.karat
              }))
          )
        ];
        setRows(itemRows);
      } catch (err) {
        setError('Failed to fetch data');
      }
      setLoading(false);
    };
    fetchData();
  }, []);

  // Group and count by karigar and karat
  const grouped = {};
  rows.forEach(row => {
    if (karigarFilter && row.karigar !== karigarFilter) return;
    if (karatFilter && row.karat !== karatFilter) return;
    const key = row.karigar + '|' + row.karat;
    if (!grouped[key]) grouped[key] = { karigar: row.karigar, karat: row.karat, count: 0 };
    grouped[key].count += 1;
  });
  const groupedRows = Object.values(grouped);

  return (
    <Container maxWidth="xl" sx={{ py: 6 }}>
      <Paper elevation={3} sx={{ p: 4 }}>
        <Box sx={{ mb: 2 }}>
          <Button startIcon={<ArrowBack />} onClick={() => navigate(-1)} variant="outlined" color="primary">Back</Button>
        </Box>
        <Typography variant="h4" gutterBottom color="primary">
          Pending Issues
        </Typography>
        <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
          <FormControl sx={{ minWidth: 180 }} size="small">
            <InputLabel>Karigar</InputLabel>
            <Select value={karigarFilter} label="Karigar" onChange={e => setKarigarFilter(e.target.value)}>
              <MenuItem value="">All</MenuItem>
              {karigars.map(k => (
                <MenuItem key={k._id || k.abbreviation} value={k.abbreviation}>
                  {k.abbreviation} - {k.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl sx={{ minWidth: 120 }} size="small">
            <InputLabel>Karat</InputLabel>
            <Select value={karatFilter} label="Karat" onChange={e => setKaratFilter(e.target.value)}>
              <MenuItem value="">All</MenuItem>
              {['22K', '24K', '22/22K', '24/24K', '18K', 'PT95', 'WG'].map(karat => (
                <MenuItem key={karat} value={karat}>{karat}</MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
        {loading ? (
          <Box display="flex" justifyContent="center" alignItems="center" minHeight={200}>
            <CircularProgress />
          </Box>
        ) : error ? (
          <Typography color="error">{error}</Typography>
        ) : (
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Karigar</TableCell>
                  <TableCell>Karat</TableCell>
                  <TableCell>Pending Count</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {groupedRows.map((row, idx) => (
                  <TableRow key={row.karigar + '-' + row.karat + '-' + idx}>
                    <TableCell>{row.karigar}</TableCell>
                    <TableCell>{row.karat}</TableCell>
                    <TableCell>{row.count}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </Paper>
    </Container>
  );
};

export default ShopPendingIssues;
